import { Grid, Typography } from "@mui/material";
import { useCallback } from "react";

function DailyProfit({ lisProfitOrLoss }) {
  const profitColor = useCallback((val) => {
    if (+val === 0) return "text.main"

    if (+val <= 0) return "error.main"

    if (+val >= 0) return "success.main"
  }, [])

  return (
    <>
      {lisProfitOrLoss?.map((item) => (
        <Grid item xs={12} pt={2}>
          <Typography
            variant="h6"
            display="flex"
            fontWeight={300}
            color="text.main"
          >
            {item?.name}:
            <Typography
              variant="h6"
              fontWeight={300}
              color={profitColor(+item?.profitOrLoss)}
              pl={0.5}
            >
              {item?.profitOrLoss > 0 && "+"}{item?.profitOrLoss} %
            </Typography>
          </Typography>
        </Grid>
      ))}
    </>
  );
}

export default DailyProfit;
